import { useTranslation } from 'react-i18next'

import { DonationOnHoldFlagProps } from './DonationOnHoldFlag.types'
import styles from './DonationOnHoldFlag.module.scss'
import { Icon, Tooltip } from '@percent/lemonade'

export function DonationOnHoldFlag({ isOnHold, reason }: DonationOnHoldFlagProps) {
  const { t } = useTranslation()

  const defaultReason = t('donation.onHold.noReason')

  if (isOnHold) {
    return (
      <div className={styles.onHoldFlag}>
        <Tooltip content={reason ?? defaultReason}>
          <span>
            <Icon name="lock" className={styles.onHoldIcon} size={5} color="alert400" />
          </span>
        </Tooltip>
      </div>
    )
  }

  return null
}
